// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// React
import { useEffect, useState } from 'react'

// UI
import { Button } from '@mantine/core'

import RetailerDisplayAddress from '@/components/retailers/RetailerDisplayAddress'
import RetailerSmallInvoiceTable from '@/components/retailers/RetailerSmallInvoiceTable'
import RetailerSmallEstimateTable from '@/components/retailers/RetailerSmallEstimateTable'
import RetailerSettings from '@/components/retailers/RetailerSettings'

// Next
import { useParams } from 'react-router-dom'
// Icons
import { IconExternalLink, IconAlertTriangle } from '@tabler/icons-react'

// UI
import ScrollableScreen from '@/components/ui/ScrollableScreen'

export default function RetailerPage() {
    const { retailer_id } = useParams()

    // Load retailer
    const [retailer, setRetailer] = useState(null)

    // API
    const { requestGet } = useAxiosApi()

    const loadRetailer = async () => {
        const { data } = await requestGet(`/retailers/${retailer_id}`)

        setRetailer(data)
    }

    useEffect(() => {
        if (retailer_id) {
            loadRetailer()
        }
    }, [retailer_id])

    // Breadcrumbs
    const breadcrumbs = [
        {
            label: 'Revendeurs',
            href: '/retailers',
        },
        {
            label: retailer?.name,
        },
    ]

    const rightSection = retailer?.sellsy_company_id && (
        <Button
            component="a"
            href={`https://www.sellsy.com/thirds/client/${retailer.sellsy_company_id}`}
            target="_blank"
            variant="default"
            leftSection={<IconExternalLink size="1rem" />}
        >
            Ouvrir dans Sellsy
        </Button>
    )

    if (!retailer) {
        return null
    }

    return (
        <ScrollableScreen breadcrumbs={breadcrumbs} rightSection={rightSection}>
            <div className="max-w-[800px] w-full mx-auto my-5 flex flex-col gap-5">
                {(!retailer.sellsy_company_id || !retailer.shipping_address?.country_code) && (
                    <div className="flex items-center gap-3 p-4 border border-amber-200 bg-amber-50 rounded-lg text-sm text-amber-800">
                        <IconAlertTriangle size={18} className="shrink-0" />
                        <span>
                            Ce revendeur ne peut pas commander via l'espace revendeur
                            {!retailer.sellsy_company_id && ' (aucun compte Sellsy associé)'}
                            {retailer.sellsy_company_id && ' (pays de livraison non renseigné)'}
                            .
                        </span>
                    </div>
                )}
                <div className="p-5 flex flex-col gap-3 border rounded-lg bg-white">
                    <div className="flex flex-col">
                        <span className="text-lg font-medium">
                            {retailer.name}
                        </span>

                        <span className="text-sm text-gray-500">
                            {retailer.sellsy_name}
                        </span>
                    </div>


                    <div className="grid grid-cols-2">
                        <RetailerDisplayAddress
                            retailer={retailer}
                            reloadRetailer={loadRetailer}
                        />

                        <RetailerSettings
                            retailer={retailer}
                            reloadRetailer={loadRetailer}
                        />
                    </div>
                </div>

                <RetailerSmallEstimateTable retailer_id={retailer.id} />

                <RetailerSmallInvoiceTable retailer_id={retailer.id} />

            </div>
        </ScrollableScreen>
    )
}
